export { default } from "./PostSingleLayout";
